exports.getSignEvent = (state, params) => state.dal.document.get(state, params)
